import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './DeleteCategoryForm.styles';
import Icon from '../../common/icon/Icon';

import Button from '../../inputs/button/Button';
import AddForm from '../addform/AddForm';
import FormActions from '../formactions/FormActions';

export class DeleteCategoryForm extends Component {
  render() {
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <div className={css(styles.text)}>
          <p className={css(styles.p)}>{`${I18n.t(
            'delete.deleteCategory.confirm'
          )} ${this.props.itemName}?`}</p>
        </div>

        <FormActions>
          <Button styles={[styles.btn, styles.confirm]}>
            <Icon value="trash" styles={styles.icon} />
            {I18n.t('delete.deleteIt')}
          </Button>
          <Button styles={[styles.btn, styles.deny]} onClick={this.props.deny}>
            <Icon value="checkmark-circle" styles={styles.icon} />
            {I18n.t('delete.keepIt')}
          </Button>
        </FormActions>
      </AddForm>
    );
  }
}

export default reduxForm({
  form: 'deleteCategory'
})(DeleteCategoryForm);



// WEBPACK FOOTER //
// ./src/components/forms/deletecategoryform/DeleteCategoryForm.js